import { mapGetters } from 'vuex';
import mvtCollapsibleLinks from '@/common/components/mvtcollapsiblelinks/mvt-collapsiblelinks.vue';
import schoolsTable from '../schoolstable/schools-table.vue';
import schoolsCardSection from '../schoolscardsection/card-section.vue';


export default {
    name: 'schoolsNeighbourhood',
    inject: ['$eventBus'],
    props: {
        data: {
            type: Object,
            default: {}
        }
    },
    components: {
        mvtCollapsibleLinks,
        schoolsCardSection,
        schoolsTable
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb'])
    },
    methods: {
        formatDataList(list) {
            return list && list.map(item => {
                return {
                    url: `${this.glb.appUrl}${item.nameForUrl}`,
                    text: item.displayName
                }
            });
        },
    },
};